import { ListAltTwoTone } from '@mui/icons-material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { LabelValue, FormGrid, Widget } from '../../../shared';
import { IStockProduct } from '../../models';

interface Props {
    stockProduct: IStockProduct;
}

export const StockProductDetail: FC<Props> = ({ stockProduct }) => {
    const { t } = useTranslation();
    return (
        <Widget title={t('product')} icon={<ListAltTwoTone color="primary" />}>
            <FormGrid size={{ xs: 6 }} containerProps={{ spacing: 1 }}>
                <LabelValue label={t('name')} value={stockProduct.name} />
                <LabelValue label={t('code')} value={stockProduct.code} />
                <LabelValue label={t('measurementUnit')} value={t(stockProduct.measurementUnit)} />
                <LabelValue label={t('weight')} value={stockProduct.weight?.toString()} />
                <LabelValue label={t('productCategory')} value={stockProduct.category?.id} />
            </FormGrid>
        </Widget>
    );
};
